var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 15.8337C7.58333 15.8337 8.33333 15.0837 8.33333 14.167V5.83366C8.33333 4.91699 7.58333 4.16699 6.66667 4.16699C5.75 4.16699 5 4.91699 5 5.83366V14.167C5 15.0837 5.75 15.8337 6.66667 15.8337ZM11.6667 5.83366V14.167C11.6667 15.0837 12.4167 15.8337 13.3333 15.8337C14.25 15.8337 15 15.0837 15 14.167V5.83366C15 4.91699 14.25 4.16699 13.3333 4.16699C12.4167 4.16699 11.6667 4.91699 11.6667 5.83366Z",
    fill: "#D8A600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.f7d2c48b59fbb88b5574d4e100c3fa25.svg";
export { ForwardRef as ReactComponent };